import { render } from "./Update.vue?vue&type=template&id=801e47e0&scoped=true&lang=true"
import script from "./Update.vue?vue&type=script&lang=js"
export * from "./Update.vue?vue&type=script&lang=js"

import "./Update.vue?vue&type=style&index=0&id=801e47e0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-801e47e0"

export default script